const CREATE_DOLL_RETURN_TO = '/client/diy-doll-group/transition-doll';

// 把后端下发的 taskUrl 转成可跳转的路径和 state
// showBack=true: 娃娃养成等特殊页面默认没有返回按钮，统一补上
export function buildTaskNavigation(taskUrl, item = {}) {
  const baseUrl = taskUrl.replace('/:teamActivityInstanceId', '');
  const separator = baseUrl.includes('?') ? '&' : '?';
  const isCreateDollTask = baseUrl.includes('/create-doll') || baseUrl.includes('/diy-doll-online');
  const extraState = isCreateDollTask ? { returnTo: CREATE_DOLL_RETURN_TO } : {};

  return {
    url: `${baseUrl}${separator}showBack=true`,
    state: { ...item.config, ...extraState },
  };
}

export function navigateToTask(navigate, taskUrl, item = {}) {
  const { url, state } = buildTaskNavigation(taskUrl, item);
  navigate(url, { state });
}
